"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFeatureFlags = void 0;
/**
 * Default values for `FeatureFlags`
 */
exports.DefaultFeatureFlags = {
    metricsDateWindowEnabled: true,
    metricsReferenceLineEnabled: true,
    metricsColorIndicatorsEnabled: true,
    metricsHistoricalComparisonsEnabled: true,
    metricsWindowSwitcherEnabled: true,
};
//# sourceMappingURL=FeatureFlags.js.map